import React from "react";
import Logout from "../User/Logout";
import Menu from "./Menu";
import Avatar from "../Components/User/Avatar";
import { useDispatch, useSelector } from "react-redux";
import { openModal } from "../Store/modalSlice";
import { Link } from "react-router-dom";
import { useAccountStatus } from "../hooks/useAccountStatus";
import { useProjectCreation } from "../hooks/useProjectCreation";
import { usePermissions } from "../hooks/usePermissions";
import { useGetUserQuery } from "../api/user";
import logoDark from '../assets/Pathbox-logo-v2-dark.png'
import logoLight from '../assets/Pathbox-logo-v2-light.png'

export default function DashboardLayout(props: any) {

    const dispatch = useDispatch();
    const { isUnlimited } = useAccountStatus();
    const {
        isProjectCreationDisabled,
        getProjectCreationTooltip
    } = useProjectCreation();
    const { data: userData } = useGetUserQuery(undefined);
    const { team } = usePermissions();
    const canInvite = team.canInviteMembers(userData?.role);

    return <div className="dashboard-layout">
        <div className="dashboard-container flex h-screen bg-gray-200 dark:bg-neutral-900">
            {/* Sidebar */}
            <div className="dashboard-sidebar bg-gray-50 dark:bg-neutral-800 w-64 flex flex-col justify-between border-r border-gray-200 dark:border-neutral-700">
                <div className="sidebar-content">
                    <div className="sidebar-logo p-20 pl-8 pt-8 pb-2">
                        <Link to="/">
                            <img alt="Pathbox logo" src={logoLight} className="dark:hidden"/>
                            <img alt="Pathbox logo" src={logoDark} className="hidden dark:block"/>
                        </Link>
                        {/* <h1 className="text-white text-2xl p-6 pr-4 pl-4">
                            Pathbox</Link>
                        </h1> */}
                    </div>
                    <div className="sidebar-actions p-4 ml-2">
                        <div className="new-item-dropdown dropdown dropdown-bottom">
                            <label tabIndex={0} className="new-item-button btn btn-md m-1">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" > <path d="M12 5V19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /> <path d="M5 12H19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /> </svg>
                            New
                            </label>
                            <ul tabIndex={0} className="new-item-menu dropdown-content z-[1] menu p-2 shadow bg-base-100 rounded-box w-52">
                                <li>
                                    <button 
                                        className={`new-project-button ${isProjectCreationDisabled ? 'opacity-50 cursor-not-allowed' : ''}`}
                                        onClick={()=> dispatch(openModal({type: 'project', props: {}}))}
                                        disabled={isProjectCreationDisabled}
                                        title={getProjectCreationTooltip()}
                                    >
                                        New Project
                                    </button>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <Menu />
                </div>
                <div className="sidebar-footer p-4">
                    {/* Unlimited account status indicator */}
                    {isUnlimited && (
                        <div className="unlimited-status-indicator bg-gradient-to-r from-green-400 to-green-600 rounded-lg p-3 shadow-lg">
                            <div className="flex items-center space-x-2">
                                <svg className="w-5 h-5 text-green-800" fill="currentColor" viewBox="0 0 24 24">
                                    <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"/>
                                </svg>
                                <div>
                                    <div className="unlimited-status-text text-green-900 font-semibold text-sm">
                                        Unlimited Account
                                    </div>
                                    <div className="unlimited-status-subtitle text-green-800 text-xs">
                                        Unlimited Usage
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>

            {/* Main content */}
            <div className="dashboard-main flex-1 flex flex-col">
                {/* Top toolbar */}
                <div className="dashboard-toolbar bg-neutral-100 dark:bg-neutral-900 p-4 shadow-xs">
                    <div className="toolbar-content flex justify-between items-center">
                        <div className="toolbar-left join">
                            {/* FOR DEMO - removed */}
                            {/* <div>
                                <div>
                                    <input className="input input-bordered join-item" placeholder="Search" />
                                </div>
                            </div>
                            <div className="indicator">
                                <button className="btn join-item">Search</button>
                            </div> */}
                        </div>
                        <div className="toolbar-right flex items-center">
                            {/* <img src="path_to_user_image.jpg" alt="User" className="h-8 w-8 rounded-full mr-4" /> */}
                            <Avatar />
                            {/* Add more user info or actions here */}
                            <Logout />
                        </div>
                    </div>
                </div>

                {/* Main content area */}
                <div className="dashboard-content flex-1 p-4 overflow-y-auto">
                    {/* Add main content here */}
                    <div className="mb-4 flex justify-end">
                        {canInvite && (
                            <button 
                                className="btn btn-sm btn-primary"
                                onClick={() => dispatch(openModal({ type: 'invite-send', width: 'md', props: {} }))}
                            >
                                Invite members
                            </button>
                        )}
                    </div>
                    {props.children}
                </div>
            </div>
        </div>
    </div>;
}